/**
 * DEV-ONLY: Shared collapsible panel shell for devtools. Used by overlay and inspector panels.
 */
import React, { useState } from "react";
import { useDevtoolsSession } from "./DevtoolsSessionContext";

export default function DevtoolsPanelShell({ title, children }) {
  const [expanded, setExpanded] = useState(true);
  const sessionApi = useDevtoolsSession();

  return (
    <div className="devtools-panel-shell">
      <div className="devtools-panel-shell__header">
        <span className="devtools-panel-shell__title">DEV — {title}</span>
        <div className="devtools-panel-shell__actions" aria-label="Devtools session actions">
          {sessionApi && (
            <>
              <button
                type="button"
                className="devtools-panel-shell__action"
                onClick={() => sessionApi.copyShareUrl?.()}
                title="Copy a shareable URL for current devtools session"
              >
                Copy URL
              </button>
              <button
                type="button"
                className="devtools-panel-shell__action devtools-panel-shell__action--danger"
                onClick={() => sessionApi.resetSession?.()}
                title="Reset saved devtools session for this route"
              >
                Reset
              </button>
            </>
          )}
          <button
            type="button"
            className="devtools-panel-shell__toggle"
            onClick={() => setExpanded((e) => !e)}
            aria-expanded={expanded}
            aria-label={expanded ? "Collapse" : "Expand"}
          >
            {expanded ? "−" : "+"}
          </button>
        </div>
      </div>
      {expanded && <div className="devtools-panel-shell__body">{children}</div>}
    </div>
  );
}
